module.exports = __webpack_public_path__ + "static/media/portfolio1 (59).e5e47e39.jpeg";